export default {
    init() {
        function calcSignaturesPercentage() {
            var total = +jQuery('#total-signatures').text();
            var goal = +jQuery('#signatures-goal').text().replace(",", "");
            var percentage = (total / goal) * 100;

            jQuery('.percentage').css("width", percentage + "%");
        }

        jQuery(document).ready(calcSignaturesPercentage);

        jQuery(document).ready(function(){
            document.addEventListener( 'wpcf7mailsent', function( event ) {
                location = '/petitions-thank-you/';
            }, false )
        });
    },
    finalize() {
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/templatePetitions.js